import { render, staticRenderFns } from "./DetailSkeleton.vue?vue&type=template&id=fdef101a&scoped=true"
import script from "./DetailSkeleton.vue?vue&type=script&lang=js"
export * from "./DetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DetailSkeleton.vue?vue&type=style&index=0&id=fdef101a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdef101a",
  null
  
)

export default component.exports